// export const setCookie = (key: string, value: string): void => {
//   document.cookie = `${encodeURIComponent(key)}=${encodeURIComponent(value)}; path=/; SameSite=Strict`;
// };

// export const getCookie = (key: string): string | null => {
//   const encodedKey = encodeURIComponent(key);
//   const match = document.cookie
//     .split("; ")
//     .find((row) => row.startsWith(`${encodedKey}=`));
//   return match ? decodeURIComponent(match.split("=")[1]) : null;
// };

// export const removeCookie = (key: string) => {
//   document.cookie = `${encodeURIComponent(key)}=; path=/; SameSite=Strict; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
// };

export const setCookie = (key: string, value: string): void => {
  localStorage.setItem(encodeURIComponent(key), encodeURIComponent(value));
};

export const getCookie = (key: string): string | null => {
  const encodedKey = encodeURIComponent(key);
  const value = localStorage.getItem(encodedKey);
  return value ? decodeURIComponent(value) : null;
};

export const removeCookie = (key: string) => {
  localStorage.removeItem(encodeURIComponent(key));
};
